module.exports = __webpack_public_path__ + "static/media/home.6dd0ef2b.svg";